import { render, staticRenderFns } from "./OnboardingStepWidget.vue?vue&type=template&id=ab10c768"
import script from "./OnboardingStepWidget.vue?vue&type=script&lang=js"
export * from "./OnboardingStepWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports